import {ApiRequest, RequestMethod} from "../../../request";

export async function deleteEquipmentCategory(id: string): Promise<boolean> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.DELETE);
    apiRequest.setUrl(`/api/equipment-category/${id}`);
    const response: any = await apiRequest.send();
    return response.status === 200;
}